import type { ValueFormatterParams } from 'ag-grid-community';
import type { ColDefFactory, Column } from '..';
import { type DateFnInput, createDateOnly, logger } from '../../../utils';
import { text } from './text';
import { dateStringComparator } from './utils';

/** DateOnly column showing yyyy-mm-dd format from ISO dates.
 * - This strictly represent the date portion of the ISO date, not the time portion, based on the rules of the DateOnly type.
 */
export const dateOnly: ColDefFactory<Column> = column => ({
  ...text(column),
  cellDataType: 'dateString',
  initialWidth: 100,
  comparator: dateStringComparator,
  valueFormatter: ({ value }: ValueFormatterParams<unknown, DateFnInput>) => {
    if (!value || value === '0') {
      return '';
    }
    try {
      // Handle numeric timestamps
      if (typeof value === 'number') {
        const date = new Date(value);
        if (isNaN(date.getTime())) {
          return '';
        }
        const dateOnlyValue = createDateOnly(date.toISOString());
        return dateOnlyValue || '';
      }

      const dateOnlyValue = createDateOnly(String(value));
      return dateOnlyValue || '';
    } catch (e) {
      logger.error(e as Error);
      return '';
    }
  },
  sortingOrder: ['desc', 'asc'],
});
